export default __webpack_public_path__ + "static/redstone-2841aca3821bcd7146d7338178523c4d.svg";